import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { SensorTransportProvider } from '../../sensors-v2/transports/SensorTransportProvider';
import { useAlarmedBoxes } from '../../sensors-v2/hooks/useAlarmedBoxes';
import { BoxStatusCard } from '../../../components/box-status-card/BoxStatusCard';

const WidgetInner: FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useAlarmedBoxes({
    sort: 'gravity_desc', page: 1, items_per_page: 5,
  });
  const boxes = data?.data ?? [];

  return (
    <div className="card mb-3">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="card-title m-0">Caixas com alarme ativo</h3>
        <button type="button" className="btn btn-link" onClick={() => navigate('/sensors-v2')}>
          Ver todas →
        </button>
      </div>
      <div className="card-body">
        {isLoading && <div className="text-muted">Carregando...</div>}
        {!isLoading && boxes.length === 0 && (
          <div className="text-center text-muted py-3">
            <div style={{ fontSize: 32 }}>✓</div>
            Tudo certo!
          </div>
        )}
        {boxes.map((b) => (
          <BoxStatusCard
            key={b.box_id}
            data={b}
            variant="compact"
            onClick={() => navigate(`/sensors-v2?box=${b.box_id}`)}
          />
        ))}
      </div>
    </div>
  );
};

export const AlarmedBoxesWidget: FC = () => (
  <SensorTransportProvider transport="websocket">
    <WidgetInner />
  </SensorTransportProvider>
);
